var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading
    ? _c("div", { staticClass: "loading-overlay" }, [
        _c("div", { staticClass: "loading-spinner" }),
        _c("p", [_vm._v(_vm._s(_vm.text) + "...")]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }